import { useEffect } from 'react';
import {jwtDecode} from 'jwt-decode';
import { isTokenExpired, logout } from './auth';
import API from '../Api/Api';
const SessionManager = () => {
    const refreshToken = async(token) =>{
        console.log('past',token);
        const response = await API.post(`/auth/refresh-token`);
        localStorage.setItem("jwt_token_jobcritic", response.token);
        console.log('recent',response.token);
    };
  useEffect(() => {
    const checkToken = setInterval(() => {
      const token = localStorage.getItem('jwt_token_jobcritic');
      if (!token) return;

      try {
            const decoded = jwtDecode(token); // Use global jwtDecode
            const currentTime = Date.now() / 1000;
            const timeLeft = decoded.exp - currentTime;
            if (timeLeft <= 300 && timeLeft > 0) {
                refreshToken(token);
                // const extendSession = window.confirm(
                //   'Your session will expire in 1 minute. Extend?'
                // );
                // if (extendSession) {
                //   //mockLogin(); // Simulate token refresh
                // } else {
                //   logout();
                // }
            }else if (isTokenExpired()) {
                logout();
            }else{
                console.log('time-check');
            }
      } catch (error) {
        console.error('Invalid token:', error);
       // logout();
      }
    }, 20000); // Check every 20 seconds

    return () => clearInterval(checkToken);
  }, []);

  return null;
};

export default SessionManager;